import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

/** Keep feedback beside the field, including while its results popover is closed. */
export default function AddressSearchStatus({ loading, ready = true, status, count = 0, error, resolving }) {
  const busy = !error && (loading || !ready || resolving);
  const message = error ? "Address search is unavailable. Try again or choose a saved address."
    : resolving ? "Confirming your address…"
    : !ready ? "Loading address search…"
    : loading ? "Searching for addresses…"
    : status === "ZERO_RESULTS" ? "No matches. Try a road, area or landmark name."
    : count ? "Choose a suggestion below to confirm your address."
    : "Start typing an address or landmark, then choose a suggestion.";
  return (
    <div role="status" aria-live="polite" aria-atomic="true" style={{ display: "flex", alignItems: "center", gap: 8, margin: "6px 0", fontSize: 13, lineHeight: 1.4, color: "inherit" }}>
      {busy && <CircularProgress size={16} color="inherit" aria-hidden="true" />}
      <span>{message}</span>
    </div>
  );
}
